export default __webpack_public_path__ + "static/media/15.c05b59a2.png";